export default __webpack_public_path__ + "static/media/warning--tractors--g4.ca6b9ca8.png";